"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProcessingFee = exports.calculatePrice = exports.calculatePromoDiscount = exports.convertToTime = exports.validOrderTime = exports.cutoffDate = exports.getCutOffDate = exports.ValidStatus = exports.DateFormat = void 0;
const partner_1 = require("./partner");
const moment_1 = __importDefault(require("moment"));
require("moment-timezone");
const checkout_1 = require("./checkout");
const promotion_1 = require("./promotion");
const order_1 = require("./order");
exports.DateFormat = "YYYY-MM-DD";
var ValidStatus;
(function (ValidStatus) {
    ValidStatus[ValidStatus["Valid"] = 1] = "Valid";
    ValidStatus[ValidStatus["StoreClosed"] = 2] = "StoreClosed";
    ValidStatus[ValidStatus["InsufficientPrep"] = 3] = "InsufficientPrep";
    ValidStatus[ValidStatus["Other"] = 4] = "Other";
})(ValidStatus = exports.ValidStatus || (exports.ValidStatus = {}));
function getCutOffDate(date, partner, orderType) {
    var _a, _b, _c, _d;
    let orderDays = orderType === checkout_1.OrderType.Pickup ? partner.pickupDays : partner.deliveryDays;
    const adjustedDate = orderType === checkout_1.OrderType.Pickup ?
        (_b = (_a = partner.adjustedDates) === null || _a === void 0 ? void 0 : _a[date.format(exports.DateFormat)]) === null || _b === void 0 ? void 0 : _b.pickupTimings :
        (_d = (_c = partner.adjustedDates) === null || _c === void 0 ? void 0 : _c[date.format(exports.DateFormat)]) === null || _d === void 0 ? void 0 : _d.deliveryTimings;
    if (orderDays && orderDays[date.day()]) {
        return cutoffDate(date, orderDays[date.day()], partner.preparationEnabled, partner.preparationDurationType, partner.preparationDuration, adjustedDate, partner.preparationInMins);
    }
}
exports.getCutOffDate = getCutOffDate;
function cutoffDate(orderDay, orderDayTimings, preparationEnabled, preparationDurationType, preparationDuration, adjustedDate, preparationInMins) {
    let orderEndTime;
    if (adjustedDate) {
        orderEndTime = {
            hours: Math.floor(adjustedDate.end / 60),
            minutes: adjustedDate.end % 60
        };
    }
    else {
        orderEndTime = {
            hours: Math.floor(orderDayTimings.end / 60),
            minutes: orderDayTimings.end % 60
        };
    }
    const cutoffDate = orderDay.clone().set({
        hours: orderEndTime.hours,
        minutes: orderEndTime.minutes,
        second: 0,
        milliseconds: 0,
    });
    if (preparationEnabled && preparationDurationType === partner_1.AdvanceDurationType.Hours) {
        cutoffDate.subtract(preparationDuration, "hours");
    }
    else if (preparationEnabled && preparationDurationType === partner_1.AdvanceDurationType.Days) {
        cutoffDate.subtract(preparationDuration, "days");
    }
    else if (!preparationEnabled) {
        cutoffDate.subtract(preparationInMins, "minutes");
    }
    return cutoffDate;
}
exports.cutoffDate = cutoffDate;
const validOrderTime = (scheduledDate, //This paramter is ignored if isNow is set to true
isNow, timezone, orderDayTimings, preparationEnabled, preparationDurationType, preparationDuration, adjustedDate, preparationTimeInMins) => {
    const currentTime = timezone ? (0, moment_1.default)().tz(timezone) : (0, moment_1.default)();
    const orderDate = isNow ? currentTime : scheduledDate;
    if (orderDate === null) {
        return ValidStatus.Other;
    }
    let open = adjustedDate ? (0, exports.convertToTime)(adjustedDate.start) : (0, exports.convertToTime)(orderDayTimings.start);
    let openDate = (0, moment_1.default)(orderDate).set({
        hour: open.hour,
        minute: open.minute,
        seconds: 0,
        milliseconds: 0
    });
    let close = adjustedDate ? (0, exports.convertToTime)(adjustedDate.end) : (0, exports.convertToTime)(orderDayTimings.end);
    let closeDate = (0, moment_1.default)(orderDate).set({
        hour: close.hour,
        minute: close.minute,
        seconds: 0,
        milliseconds: 0
    });
    //Check date falls within open and close times for store
    if (orderDate < openDate || orderDate > closeDate) {
        return ValidStatus.StoreClosed;
    }
    //Ensure sufficient prep time has been provided for the order
    let latestOrder;
    if (preparationEnabled) {
        latestOrder = (0, moment_1.default)(orderDate);
        if (preparationDurationType === partner_1.AdvanceDurationType.Hours) {
            latestOrder.subtract(preparationDuration, 'hours');
        }
        else if (preparationDurationType === partner_1.AdvanceDurationType.Days) {
            latestOrder.set({
                hour: close.hour,
                minute: close.minute
            }).subtract(preparationDuration, 'day');
        }
    }
    else {
        // Ensure enough time has been given for the order to be prepared
        let earliestOrder = (0, moment_1.default)().add(preparationTimeInMins, 'minutes');
        if (!isNow && orderDate.isBefore(earliestOrder)) {
            return ValidStatus.InsufficientPrep;
        }
        // Ensure enough time has been given for the order to be prepared before closure
        latestOrder = (0, moment_1.default)(closeDate);
        if (preparationTimeInMins) {
            latestOrder.subtract(preparationTimeInMins, 'minutes');
        }
    }
    if (currentTime <= latestOrder) {
        return ValidStatus.Valid;
    }
    else {
        return ValidStatus.InsufficientPrep;
    }
};
exports.validOrderTime = validOrderTime;
const convertToTime = (minutes) => {
    const convertedHour = Math.floor(minutes / 60);
    const convertedMinute = Math.floor(minutes % 60);
    const converted24HourTime = `${convertedHour < 10 ? `0${convertedHour}` : convertedHour}:${convertedMinute < 10 ? `0${convertedMinute}` : convertedMinute}`;
    const converted12Hour = convertedHour > 12 ? convertedHour % 12 : convertedHour;
    let converted12HourTime;
    if (converted12Hour === 0 && convertedMinute === 0) {
        converted12HourTime = 'Midnight';
    }
    else {
        converted12HourTime = `${converted12Hour === 0 ? 12 : converted12Hour}:${convertedMinute < 10 ? `0${convertedMinute}` : convertedMinute} ${convertedHour < 12 ? 'am' : 'pm'}`;
    }
    return {
        hour: convertedHour,
        minute: convertedMinute,
        formatted: converted24HourTime,
        formatted12: converted12HourTime
    };
};
exports.convertToTime = convertToTime;
function calculatePromoDiscount(orderSubTotal, promo) {
    if (promo.type === promotion_1.PromoType.percentage) {
        const amount = Math.round(orderSubTotal * promo.amount);
        if (promo.maxAmount && amount > promo.maxAmount) {
            return promo.maxAmount;
        }
        else {
            return amount;
        }
    }
    else if (promo.type === promotion_1.PromoType.fixed) {
        return promo.amount;
    }
    else {
        return 0;
    }
}
exports.calculatePromoDiscount = calculatePromoDiscount;
function calculatePrice(basePrice, itemCount, modifiers) {
    var _a;
    let total = basePrice;
    if (modifiers) {
        for (const selectedModifier of modifiers) {
            for (const option of selectedModifier.selectedOptions) {
                const optionDetails = selectedModifier.options.find((val) => val.label === option);
                total += (_a = optionDetails === null || optionDetails === void 0 ? void 0 : optionDetails.price) !== null && _a !== void 0 ? _a : 0;
            }
        }
    }
    return total * itemCount;
}
exports.calculatePrice = calculatePrice;
function calculateWebsiteProcessingFee(orderData) {
    // Processing fee should not be applied to the service fee, or the payment fee if charged seperately
    const orderTotal = orderData.total - orderData.refundTotal - orderData.serviceFee - (orderData.paymentFeeAbsorbed ? 0 : orderData.paymentFee);
    return Math.round(orderTotal * order_1.WEBSITE_PROCESSING_FEE);
}
function calculateAppProcessingFee(orderData) {
    // Processing fee should not be applied to the service fee
    const orderTotal = orderData.total - orderData.refundTotal - orderData.serviceFee;
    return Math.round(orderTotal * order_1.COMMISSON_FEE);
}
function calculateProcessingFee(orderData) {
    let processingFeeRate;
    let processingFee;
    if (orderData.isPartnerWebsite) {
        processingFeeRate = order_1.WEBSITE_PROCESSING_FEE;
        processingFee = calculateWebsiteProcessingFee(orderData);
    }
    else {
        processingFeeRate = order_1.COMMISSON_FEE;
        processingFee = calculateAppProcessingFee(orderData);
    }
    return {
        processingFeeRate,
        processingFee
    };
}
exports.calculateProcessingFee = calculateProcessingFee;
